export const languages = {
  ar: 'عربى',
  cs: 'Čeština',
  de: 'Deutsch',
  en: 'English',
  fr: 'Français',
} as const
